<div class="playlist-overlay__container" (click)="onBtnClicked()">
  <button mat-raised-button class="playlist-overlay__count"
          [matBadge]="pendingSongs.size" matBadgePosition="before" >
    <mat-icon>playlist_add</mat-icon>
  </button>
</div>
